import { useState, useEffect, useRef, Fragment } from "react";
import { useParams, useHistory } from "react-router-dom";

import { API_URL, scroll, getValFromLS, isFieldError } from "../../helpers";

import Hdg from "../../components/Hdg";
import Select from "../../components/Select";
import Alert from "../../components/Alert";
import Input from "../../components/Input";
import Checkbox from "../../components/Checkbox";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

import Radios from "./Radios";

const Edit = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();
	const formElement = useRef();
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardHotelEditInit`);
			const params = {
				id: auth.id ? auth.id : "",
				q: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });

					setDetails({
						...json,
					});

					setNames((names) => ({
						...names,
						bed: json.bed,
						name: json.name,
						email: json.email,
						sun1: json.sun1,
						mon1: json.mon1,
						tue1: json.tue1,
						wed1: json.wed1,
						thu1: json.thu1,
						fri1: json.fri1,
						sat1: json.sat1,
						sun2: json.sun2,
						mon2: json.mon2,
						wed1Selected: json.wed1Selected,
						thu1Selected: json.thu1Selected,
						fri1Selected: json.fri1Selected,
						sat1Selected: json.sat1Selected,
						sun2Selected: json.sun2Selected,
					}));

					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardHotel`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (
				key === "sun1" ||
				key === "mon1" ||
				key === "tue1" ||
				key === "wed1" ||
				key === "thu1" ||
				key === "fri1" ||
				key === "sat1" ||
				key === "sun2" ||
				key === "mon2"
			) {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("roomId", details.roomId);
		if (details.hotel !== "JW Marriott") {
			data.append("wed1Selected", names.wed1 ? "wed1" : "");
			data.append("thu1Selected", names.thu1 ? "thu1" : "");
			data.append("fri1Selected", names.fri1 ? "fri1" : "");
			data.append("sat1Selected", names.sat1 ? "sat1" : "");
			data.append("sun2Selected", names.sun2 ? "sun2" : "");
		}
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/dashboard/hotel`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Dashboard" />
						<p>Use this form to edit a room request.</p>

						<table
							className="approved assigned"
							style={{ marginTop: "15px", marginBottom: "15px" }}
						>
							<thead>
								<tr>
									<th className="center" style={{ width: "15%" }}>
										ID
									</th>
									<th className="center" style={{ width: "15%" }}>
										Hotel
									</th>
									<th className="center" style={{ width: "30%" }}>
										Occupant
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="center">{details.roomId}</td>
									<td className="center">{details.hotel}</td>
									<td className="center">{`${details.name} (${details.email})`}</td>
								</tr>
							</tbody>
						</table>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Edit a Room Request
							</h4>

							<div className="form-group">
								<Select
									name="bed"
									label="Bed Preference (not guaranteed)"
									reqd={true}
									value={names.bed}
									options={[
										{ id: "", name: "--" },
										{ id: "nopref", name: "No Preference" },
										{ id: "king", name: "1 King Bed" },
										{ id: "double", name: "2 Queen Beds" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "bed")}
								/>

								<div />
							</div>

							<div className="form-group">
								<Input
									name="name"
									label="Name"
									reqd={true}
									value={names.name}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<h4
								style={{
									marginTop: "20px",
									lineHeight: "22px",
									marginBottom: "0",
									fontSize: "1.1rem",
								}}
							>
								Include the Following Nights
							</h4>

							<div className="checkbox-grid">
								{details.nights.map((item) => {
									return (
										<Fragment key={item.name}>
											<div
												className="form-group checkbox"
												style={{
													marginLeft: "15px",
													marginTop: "0",
													marginBottom: "5px",
												}}
											>
												<Checkbox
													name={item.name}
													label={item.label}
													checked={names[item.name]}
													click={handleUpdate}
													disabled={item.disable}
												/>
											</div>
											{details.hotel === "JW Marriott" && item.radio.value && (
												<Radios
													hidden={names[item.name] ? false : true}
													name={`${item.name}Selected`}
													value={item.radio.value}
													label={item.radio.label}
													checked={item.radio.checked}
													disabled={item.radio.disabled}
													value2={item.name}
													label2="Request night, room not guaranteed"
													checked2={item.radio2.checked}
													disabled2={false}
													click={handleUpdate}
												/>
											)}
										</Fragment>
									);
								})}
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/dashboard/hotel"
										left="Back"
										submit="Edit Room Allocation / Request"
									/>
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Edit;
